import { createReducer, reducerSwitch } from 'lib/redux/reducerUtils'
import { SET_EXPERIMENT, UPDATE_APPLE_PAY_AVAILABLE, UPDATE_GOOGLE_PAY_AVAILABLE, SET_OPTIMIZELY_EXPERIMENT, API_CALL_REQUEST, API_CALL_FAILURE, API_CALL_SUCCESS, GSI_SCRIPT_LOADED } from 'actions/actionConstants'
import { FETCH_MERCHANT_FEE_CONFIG } from 'actions/apiActionConstants'

export const initialSystemState: App.SystemState = {
  appBannerCookie: false,
  customerPortalURL: undefined,
  originalCanonicalURL: undefined,
  headlessMode: false,
  experiments: {},
  canPayWithApplePay: false,
  canPayWithGooglePay: false,
  storeMode: false,
  referrer: '',
  userAgent: {
    osName: '',
    browserName: '',
  },
  previewMode: false,
  optimizelyAnonymousUserId: '',
  optimizelyExperiments: {},
  merchantFeeConfigs: [],
  gsiLoaded: false,
}

const apiRequests = reducerSwitch<App.SystemState>({
  [FETCH_MERCHANT_FEE_CONFIG]: () => ({
    merchantFeeConfigs: [],
  }),
})

const apiSuccesses = reducerSwitch<App.SystemState>({
  [FETCH_MERCHANT_FEE_CONFIG]: (_state, action) => ({
    merchantFeeConfigs: action.data,
  }),
})

const apiFailures = reducerSwitch<App.SystemState>({
})

export default createReducer<App.SystemState>(initialSystemState, {
  [API_CALL_REQUEST]: (state, action) => apiRequests(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailures(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccesses(action.api)(state, action),
  [SET_EXPERIMENT]: (state, action) => ({
    experiments: {
      ...state.experiments,
      [action.experimentID]: action.value,
    },
  }),

  [UPDATE_APPLE_PAY_AVAILABLE]: (_state, action) => ({
    canPayWithApplePay: action.value,
  }),

  [UPDATE_GOOGLE_PAY_AVAILABLE]: (_state, action) => ({
    canPayWithGooglePay: action.value,
  }),

  [SET_OPTIMIZELY_EXPERIMENT]: (state, action) => ({
    optimizelyExperiments: {
      ...state.optimizelyExperiments,
      [action.flagKey]: action.value,
    },
  }),
  [GSI_SCRIPT_LOADED]: () => ({
    gsiLoaded: true,
  }),
})
